import { Injectable } from '@angular/core';
import { UsersApiService } from '@core/services/users-api.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadSession, loadSessionFailure, loadSessionSuccess } from '@shared/actions/load-session.actions';
import { Config } from '@shared/models/config';
import { User } from '@shared/models/user';
import { ToastService } from '@shared/services/toast.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';
@Injectable()
export class LoadSessionEffects {
  constructor(
    private actions$: Actions,
    private usersApiService: UsersApiService,
    private toastService: ToastService,
  ) {}

  loadSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSession),
      switchMap(() => {
        return this.usersApiService.session().pipe(
          map((response: { data: User; config: Config }) => {
            return loadSessionSuccess({ session: response.data.attributes, config: response.config });
          }),
          catchError((error) => {
            return of(loadSessionFailure({ error }));
          }),
        );
      }),
    ),
  );

  loadSessionFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadSessionFailure),
        tap(() => {
          this.toastService.showToast('error', 'Failed to load session.');
        }),
      ),
    { dispatch: false },
  );
}
